import React, { useState, useEffect } from "react";
import { db } from "../Firebase/firebase-config";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { ref, onValue, update } from "firebase/database";
import "./NewOffers.css";
import { FaInfoCircle } from "react-icons/fa";

function NewOffers() {
  const [offers, setOffers] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [sessionExpired, setSessionExpired] = useState(false);
  const [userUid, setUserUid] = useState(null);

  useEffect(() => {
    const auth = getAuth();

    if (!navigator.onLine) {
      setError("You are offline. Please check your internet connection.");
      setLoading(false);
      return;
    }

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserUid(user.uid);
        setSessionExpired(false);
      } else {
        setSessionExpired(true);
        setUserUid(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Fetch offers real-time
  useEffect(() => {
    if (!userUid) return;

    const offersRef = ref(db, "offers");

    const unsubscribe = onValue(
      offersRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          let fetchedOffers = [];

          Object.keys(data).forEach((brand) => {
            Object.keys(data[brand]).forEach((offerId) => {
              fetchedOffers.push({
                id: offerId,
                brand,
                ...data[brand][offerId],
              });
            });
          });

          // Sort offers by timestamp descending to show newest on top (assuming 'timestamp' is a number or parsable date)
          fetchedOffers.sort((a, b) => {
  const timeA = a.timestamp ? new Date(a.timestamp).getTime() : 0;
  const timeB = b.timestamp ? new Date(b.timestamp).getTime() : 0;
  return timeB - timeA; // newest first
});


          setOffers(fetchedOffers);
        } else {
          setOffers([]);
        }
      },
      (error) => {
        setError("Failed to load offers: " + error.message);
      }
    );

    return () => unsubscribe();
  }, [userUid]);

  // Mark all current offers as viewed for this user on page load
  useEffect(() => {
    if (!userUid) return;

    const markAsViewed = () => {
      const offersRef = ref(db, "offers");

      onValue(offersRef, (snapshot) => {
        if (snapshot.exists()) {
          const updates = {};
          const data = snapshot.val();

          Object.keys(data).forEach((brand) => {
            Object.keys(data[brand]).forEach((offerId) => {
              const key = `${brand}-${offerId}`;
              updates[`user_viewed_offers/${userUid}/${key}`] = true;
            });
          });

          update(ref(db), updates).catch((error) =>
            console.error("Error marking offers as viewed:", error)
          );
        }
      }, { onlyOnce: true });
    };

    markAsViewed();
  }, [userUid]);

  const offerInfo = () => {
    alert("This section displays new offers sent by the supplier based on your interest. Each offer includes brand details, price, discounts, and validity. Review the offer carefully and take necessary action—accept, negotiate, or ignore—before the offer expires.")
  }

  if (sessionExpired) {
    return (
      <p className="text-center mt-5 text-danger fw-bold">
        Session expired. Please login again.
      </p>
    );
  }

  if (error) {
    return (
      <p className="text-center mt-5 text-danger fw-bold">
        {error}
      </p>
    );
  }

  if (loading) {
    return <p className="text-center mt-5 fw-semibold">Loading offers...</p>;
  }

  return (
    <div className="container-fluid new-offer-cont">
      <div className="new-offers-container">
        <h2 className="newoffer-Text">New Offers <FaInfoCircle onClick={offerInfo} className="info-Icon" /></h2>

        <div className="offers-list">
          {offers.length > 0 ? (
            offers.map((offer) => (
              <div key={offer.id} className="offer-card">
                <h4>
                  {offer.title} - <span className="brand">{offer.brand}</span>
                </h4>
                <p className="offer-des">{offer.description}</p>
                <h6>
                  <strong>Price:</strong> {offer.price}
                </h6>
                <h6>
                  <strong>Validity:</strong> {offer.validity}
                </h6>
              </div>
            ))
          ) : (
            <p className="no-offers">No offers available at the moment.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default NewOffers;